export default (state = {}, action) => {
    switch (action.type) {
        case 'MONTH_ITEMS_SET_SUCCESS':
            return {
                ...state,
                ...action.monthItems
            };
        case 'CLEAR_MONTH_ITEMS':
            return {};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/monthitems.js